/**
 * Sets a class -is-scrolled on the body when the user scrolled over a certain
 * threshold which defaults to 64px (default header height).
 * @param {int} scrollThreshold 
 */
export function SetupIsScrolledDetector() {
  let isScrolled = false;

  window.addEventListener('scroll', () => isScrolled = handleScroll(isScrolled))
  isScrolled = handleScroll(isScrolled);
}

export function handleScroll(isScrolled, scrollThreshold = 64, classToAdd = "-is-scrolled") {
  if (!isScrolled && window.scrollY > scrollThreshold) {
    document.body.classList.add(classToAdd);
    return true;
  } else if (isScrolled && window.scrollY <= scrollThreshold) {
    document.body.classList.remove(classToAdd);
    return false;
  }
}